export default class CommandProcessor {
    constructor(tileState) {
        this.tileState = tileState;
        this.tileReflect = 0;
        this.color = '#000212'
        this.debug = 0;
        this.outOfBounds = 0;
    }
}

